module.exports = __webpack_public_path__ + "media/images/Welcome-rafiki-423007eaa5f99717a22ce96d4053b3d6.jpg";